<!--
 * @Author: zhujuan
 * @Date: 2022-01-17 11:08:28
 * @LastEditors: zhujuan zhujuan@winning.com.cn
 * @LastEditTime: 2023-10-13 14:57:28
 * @Description: 
 * @FilePath: /nqc-pc-ui/src/common/components/PopoverNurse/module/AddNurse.vue
-->
<template>
  <div class="popover-content">
    <div class="popover-warp-title">接收人选择</div>
    <div class="popup-search full flex flex-between">
      <div class="popup-search-right">
        <w-input
          v-model="Query"
          suf-append="button"
          placeholder="姓名、拼音首拼、工号"
          clearable
          @keyup.enter.native="fetchData()"
        >
          <template slot="suf-append">
            <i
              class="w-icon-search expand-range"
              style="width: 34px"
              @click="fetchData()"
            ></i>
          </template>
        </w-input>
      </div>
    </div>
    <w-table ref="multiTable" :data="tableData" border :height="320">
      <w-table-column width="65" label="选择">
        <template slot-scope="scope">
          <w-radio
            v-model="tableRadio"
            :disabled="scope.row.disabled"
            class="radio"
            :label="scope.row.Jsr"
            >&nbsp;</w-radio
          >
        </template>
      </w-table-column>
      <w-table-column
        prop="Jsrqc"
        label="姓名"
        width="160"
        show-overflow-tooltip
      ></w-table-column>
      <!-- <w-table-column
        prop="Jsr"
        label="工号"
        width="90"
        show-overflow-tooltip
      ></w-table-column> -->
      <w-table-column
        prop="Remark"
        label="说明"
        show-overflow-tooltip
      ></w-table-column>
    </w-table>
  </div>
</template>

<script>
import WnTable from '@/common/components/WnTable'
import _ from 'lodash'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'AddNurse',
  components: { WnTable },
  props: {
    keyName: {
      type: Object,
      default: () => {}
    },
    row: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      Query: '',
      tableData: [],
      tableDataCopy: [],
      tableRadio: ''
    }
  },
  watch: {
    row(val) {
      // this.tableData = val.JsrList
    }
  },

  mounted() {},

  created() {
    const currentKsdm = this.row.NeedShowProblemInfoList[this.index].Ksdm //当前接收科室
    const disabledList = [] //当前科室下已选接收人

    this.row.NeedShowProblemInfoList.map((v, index) => {
      if (v.Ksdm == currentKsdm && index !== this.index) {
        disabledList.push(v.Jsr)
      }
    })

    if (this.row.isErgodicList) {
      this.tableData = this.row.NeedShowProblemInfoList[this.index].JsrList
    } else {
      this.tableData = this.row.JsrList
    }

    this.tableData.forEach((v) => {
      v.disabled = disabledList.includes(v.Jsr)
    })
    // this.tableData = this.row.JsrLis
    this.tableDataCopy = JSON.parse(JSON.stringify(this.tableData))

    // 下发比较特殊
    if (this.row.isErgodicList) {
      this.tableRadio = this.row.NeedShowProblemInfoList[this.index].Jsr
      return
    }

    if (!this.row[this.keyName.key]) return
    // 没有默认数组，自己拼接id和name
    this.tableRadio = this.row[this.keyName.key]
  },
  methods: {
    fetchData() {
      this.tableData = this.tableDataCopy.filter((item) => {
        return (
          item.Jsrqc.includes(this.Query) ||
          item.Jsr.includes(this.Query) ||
          item.Py?.includes(this.Query) ||
          item.Wb?.includes(this.Query)
        )
      })
    },
    //通过ID获取name1
    getPersonName() {
      let detail = JSON.parse(JSON.stringify(this.row))
      detail[this.keyName.key] = this.tableRadio
      detail[this.keyName.name] = this.tableRadio
        ? this.tableDataCopy.find((i) => i.Jsr == this.tableRadio).Jsrqc
        : ''
      return detail
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../PopoverPerson/style.scss';
.popover-content {
  width: 580px;
  height: 380px;
}
/deep/ .radio {
  transform: translateX(5px);
}
.popup-search {
  /deep/.is-button {
    padding: 0px !important;
  }
  .expand-range {
    width: 34px;
  }
}

/deep/ .w-radio.is-disabled .w-radio__inner {
  background: #f1f1f1;
  border-color: #ddd;
}
</style>
